namespace RedBullMOBILE360.CVM {
    export class CriteriaConditionColumns {
        static columnsKey = 'CVM.CriteriaCondition';
    }
}